<div class="formulas-layout">
  <div class="title-bar title-bar--responsive formulas-header">
    <div class="title-bar__heading formulas-header__title">
      <h1>FORMULAS</h1>
      <app-help screen="formulas"></app-help>
    </div>
    <div class="title-bar__actions formulas-header__actions">
      <button mat-flat-button color="primary" class="formulas-header__button" (click)="createFormula()">
        <mat-icon fontIcon="add" aria-hidden="true"></mat-icon>
        <span>New Formula</span>
      </button>
      <app-aid-year [disabled]="false"></app-aid-year>
    </div>
  </div>

  <mat-card appearance="outlined">
    @if (cc.formulas | async; as formulas) {
      <div>
        @if (formulas.length > 0) {
          <div class="formulas-grid-wrapper" appKeyboardScrollable>
            <table class="table table-hover formulas-grid">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">
                    Usage
                    <br />
                    <span class="legend-population">Population</span>
                    <span class="legend-cost">Cost</span>
                    <span class="legend-package">Package</span>
                    <span class="legend-table">Table</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (formula of formulas; track trackByFormulaId($index, formula)) {
                  <tr
                    class="formulas-row"
                    (click)="openFormula(formula)"
                    >
                    <th scope="row">
                      <a
                        class="link"
                        role="button"
                        tabindex="0"
                        (click)="activateFormula($event, formula)"
                        (keydown.enter)="activateFormula($event, formula)"
                        (keydown.space)="activateFormula($event, formula)"
                        >
                        {{ formula.name }}
                      </a>
                      <div class="description" [innerHTML]="formula.description"></div>
                    </th>
                    <td>
                      <app-usage entityType="Formula" [entityId]="formula.formulaId"></app-usage>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="formulas-empty">
            <mat-icon fontIcon="inbox" aria-hidden="true"></mat-icon>
            <p>There are no formulas yet.</p>
            <button mat-stroked-button color="primary" (click)="createFormula()">Add your first formula</button>
          </div>
        }
      </div>
    }
  </mat-card>
</div>
